import { Box, Grid, useTheme } from "@mui/material"
import { ReactElement } from "react"
import useTableStyles from "../../../styles/useTableStyles"
interface PropTypes{
    children: ReactElement
}
const TableContainer=(props:PropTypes)=>{
    const {children}= props
    const theme= useTheme()
    const tableStyle= useTableStyles()
    return (
        <Grid container item width={"100%"} sx={{ width: "100%" }}>
            <Box
             id={"scrollable"}
             display={"flex"}
             flexDirection="column"
             width="100%"
             justifyContent={"start"}
             height="65vh"
             border={theme.border?.newGreyBorder}
             sx={{
               overflowX: "scroll",
               overflowY: "scroll",
               ...tableStyle.scrollbar,
             }}
            >
            {children}
            </Box>
        </Grid>
    )
}
export default TableContainer